export default __webpack_public_path__ + "static/media/Group332@2x.344fa782.png";